import { useBizQuery, useBizMutation } from './useBizQuery';
import { GenericComment, GenericCommentObjectType } from '../Types/genericComment';
import { getComments, addComment, updateComment, deleteComment } from '../Services/genericComment';

const QUERYKEY_GENERIC_COMMENTS = 'GENERIC_COMMENTS';

export const useGetGenericComments = (objectType: GenericCommentObjectType, objectId: number) => {
    const enabled = objectId > 0;
    const { data, statusState } = useBizQuery(
        [QUERYKEY_GENERIC_COMMENTS, objectType, objectId],
        () => getComments(objectType, objectId),
        enabled
    );
    return { data: data ?? [], statusState };
};

export const useAddGenericComment = () => {
    const addCommentWrapperFn = (params: { comment: Partial<GenericComment> }) => {
        return addComment(params.comment);
    };

    const { mutate, statusState, data } = useBizMutation(addCommentWrapperFn, {
        getQueryKeyForInvalidation: ({ comment }) => [
            [QUERYKEY_GENERIC_COMMENTS, comment.ObjectType, comment.ObjectId]
        ],
    });

    return {
        addComment: (comment: Partial<GenericComment>) => mutate({ comment }),
        statusState,
        result: data,
    };
};

export const useUpdateGenericComment = () => {
    const updateCommentWrapperFn = (params: { comment: Partial<GenericComment> }) => {
        return updateComment(params.comment);
    };

    const { mutate, statusState, data } = useBizMutation(updateCommentWrapperFn, {
        getQueryKeyForInvalidation: ({ comment }) => [
            [QUERYKEY_GENERIC_COMMENTS, comment.ObjectType, comment.ObjectId]
        ],
    });

    return {
        updateComment: (comment: Partial<GenericComment>) => mutate({ comment }),
        statusState,
        result: data,
    };
};

export const useDeleteGenericComment = () => {
    const deleteCommentWrapperFn = (params: { commentId: number; objectType: GenericCommentObjectType; objectId: number }) => {
        return deleteComment(params.commentId);
    };

    const { mutate, statusState } = useBizMutation(deleteCommentWrapperFn, {
        getQueryKeyForInvalidation: ({ objectType, objectId }) => [
            [QUERYKEY_GENERIC_COMMENTS, objectType, objectId]
        ],
    });

    return {
        deleteComment: (commentId: number, objectType: GenericCommentObjectType, objectId: number) => 
            mutate({ commentId, objectType, objectId }),
        statusState,
    };
};